<template>
  <div class="main">
    <Breadcrumb
      class="breadcrumb"
      separator="<span style='color:#515a6e'>></span>"
    >
      <BreadcrumbItem to="/"
        ><span style="color: #2849bc">{{
          $t("wallet.home")
        }}</span></BreadcrumbItem
      >
      <BreadcrumbItem to="">{{ $t("wallet.wallet_address") }}</BreadcrumbItem>
    </Breadcrumb>
    <div class="accountinfo">
      <div class="address">
        <span>{{
          codeAddress ? $t("account.contractTit") : $t("account.tit")
        }}</span
        >：{{ addr }}
        <Tooltip
          :content="codeAddress ? $t('qrContract') : $t('qr')"
          placement="top"
          ><i class="iconfont icon-erweima" @click="qr = true"></i
        ></Tooltip>
        <Tooltip
          :content="codeAddress ? $t('copyContract') : $t('copy')"
          placement="top"
          ><i
            class="iconfont icon-fuzhi"
            v-clipboard:copy="addr"
            v-clipboard:success="copysuc"
            v-clipboard:error="copyerr"
          ></i
        ></Tooltip>
        <span
          v-if="codeAddress"
          class="nft"
          @click="$router.push(`/contract_info/${codeAddress}`)"
          >{{ $t("account.contractInfo") }} >></span
        >
      </div>
      <div v-if="balancesList.length !== 0">
        <ul class="balance">
          <li>
            {{ balancesList[0].currency }} {{ $t("wallet.balance") }}：<span
              class="val"
              >{{ balancesList[0].value }}</span
            >
            <span class="err" style="margin-left: 10px">{{
              balancesList[0].counterparty
                ? `(${balancesList[0].counterparty})`
                : ""
            }}</span>
          </li>
          <li class="assets" v-if="balancesList.length > 1">
            {{ $t("wallet.passport") }}：<a href="javascript:;" @click="more"
              >{{ $t("wallet.more") }}>></a
            ><span class="uni">{{ balancesList[1].currency }}</span
            ><span class="value">{{ balancesList[1].value }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-box"  v-if="codeAddress">
      <RadioGroup
        v-model="currentTab"
        type="button"
        button-style="solid"
        @on-change="handleTabChange"
      >
        <Radio label="transfer">{{ $t("account.txs") }}</Radio>
        <Radio label="contract">{{ $t("account.contract") }}</Radio>
      </RadioGroup>
    </div>
    <div v-if="currentTab === 'transfer'">
      <div class="accountlist">
        <Table
          :columns="thead"
          :data="data"
          size="small"
          :no-data-text="$t('nodata')"
          :loading="loading"
        ></Table>
      </div>
      <div class="more" v-if="ismore">
        <Button type="primary" ghost @click="loadMore" :loading="pageLoading">{{
          $t("wallet.loadmore")
        }}</Button>
      </div>
    </div>
    <template v-if="currentTab === 'contract'">
      <div class="form-box">
        <div class="form-item">
          <label for="">{{ $t("account.method") }}:</label>
          <div class="input-text">
            <Input v-model="form.opt" />
          </div>
        </div>

        <div class="form-item">
          <label for="">{{ $t("account.params") }}:</label>
          <div class="input-text">
            <Input v-model="form.args" type="textarea" :rows="4" />
          </div>
        </div>
        <div class="form-btn">
          <Button type="primary" @click="queryContract" :loading="queryLoading"
            >{{ $t("account.query") }}</Button
          >
        </div>
        <!-- <Form style="margin-top: 10px">
        <FormItem label="查询方法:">
          <input v-model="form.opt" type="text" style="width: 50%" />
        </FormItem>
        <FormItem label="查询参数:">
          <textarea v-model="form.args" type="textarea" style="width: 50%" />
        </FormItem>
        <Button
          type="primary"
          ghost
          @click="queryContract"
          :loading="queryLoading"
          >{{ "查询" }}</Button
        >
      </Form> 
       <span>结果 </span>
      <div class="remark-body" style="color: #0b0b0b">
        {{ result }}
      </div> -->
      </div>
      <div class="relult-box">
        <p class="relult-tit">
          <span>{{ $t("account.result") }}</span>
          <span v-if="contractResult.status == 'error'" class="f">{{ $t("account.fail") }}</span>
          <span v-if="contractResult.status == 'success'" class="s">{{ $t("account.success") }}</span>
        </p>
        <div class="relult-text">
          <b-code-editor
            v-if="isJSON"
            v-model="contractResult.result"
            :auto-format="true"
            ref="editor"
            :show-number="true"
            :readonly="true"
            :lint="true"
          />
          <div v-else class="text-txt">
            {{ contractResult.result }}
          </div>
        </div>
        <div class="float-operate" v-if="contractResult.result">
          <Tooltip :content="$t('account.copy')" placement="top">
            <span
              v-clipboard:copy="contractResult.result"
              v-clipboard:success="copysuc"
              v-clipboard:error="copyerr"
            >
              <Icon type="ios-photos-outline" />
            </span>
          </Tooltip>
          <!-- <Tooltip content="格式化结果" placement="top"
              ><span @click="formatDeployParameter">
                <Icon type="md-code-working" /> </span
            ></Tooltip> -->
        </div>
      </div>
    </template>

    <Modal
      :title="codeAddress ? $t('account.contractTit') : $t('account.tit')"
      footer-hide
      v-model="qr"
      class-name="vertical-center-modal"
    >
      <div style="text-align: center">
        <vue-qr
          :text="addr"
          :margin="0"
          :logoSrc="logoSrc"
          :size="300"
        ></vue-qr>
      </div>
      <div class="w-addr">{{ addr }}</div>
    </Modal>
  </div>
</template>

<script>
import {
  Table,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  Tooltip,
  Select,
  Option,
  RadioGroup,
  Radio,
  Form,
  FormItem,
  Input,
  Icon,
} from "iview";
import api from "../common/api";
import VueQr from "vue-qr";
import dayjs from "dayjs";
import BigNumber from "bignumber.js";
import { formatJson } from "../common/lib/tojson.js";
export default {
  name: "Account",
  components: {
    Table,
    Button,
    Breadcrumb,
    BreadcrumbItem,
    Modal,
    VueQr,
    Tooltip,
    Select,
    Option,
    RadioGroup,
    Radio,
    Form,
    FormItem,
    Input,
    Icon,
  },
  data() {
    return {
      balance: 0,
      secondBalance: 0,
      codeAddress: "",
      loading: false,
      pageLoading: false,
      queryLoading: false,
      limit: 15,
      marker: "",
      ismore: false,
      qr: false,
      addr: this.$route.query.address,
      logoSrc: require("../assets/images/qrlogo.png"),
      choose: "",
      balancesList: [],
      currentTab: "transfer",
      form: {},
      contractResult: { status: "", result: "" },
      isJSON: false,
      thead: [
        {
          title: this.$t("wallet.hash"),
          key: "hash",
          width: 500,
          render: (h, param) => {
            return h(
              "router-link",
              {
                style: {
                  color:
                    param.row.result == "tesSUCCESS"
                      ? "sdc-mainColor1"
                      : "#db5039",
                },
                props: {
                  to: "/hash?hash=" + param.row.hash,
                },
              },
              param.row.hash
            );
          },
        },
        {
          title: this.$t("wallet.type"),
          key: "type",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color:
                    params.row.sourceType == "Payment"
                      ? this.$route.query.address == params.row.account
                        ? "#e68911"
                        : this.$route.query.address != params.row.account &&
                          this.$route.query.address == params.row.destination
                        ? "#228B22"
                        : "#515b6e"
                      : "#515b6e",
                },
              },
              params.row.type
            );
          },
        },
        {
          title: this.$t("wallet.num"),
          key: "count",
          align: "right",
        },
        {
          title: this.$t("wallet.time"),
          key: "time",
          align: "right",
        },
      ],
      data: [],
    };
  },
  created() {
    this.loading = true;
    this.accounts();
    this.balances();
  },
  watch: {
    "$route.query.address"() {
      this.marker = "";
      this.data = [];
      this.balancesList = [];
      this.addr = this.$route.query.address;
      this.accounts();
      this.balances();
    },
  },
  methods: {
    copysuc(e) {
      this.$Message.success(this.$t("copysuc"));
    },
    copyerr(e) {
      this.$Message.error(this.$t("copyerr"));
    },
    balances() {
      let balancesPromise = this.$axios(
        `${api.balances}?address=${this.$route.query.address}`
      );
      let secondBalancesPromise = this.$axios(
        `${api.secondBalances}?address=${this.$route.query.address}`
      );
      Promise.all([balancesPromise, secondBalancesPromise])
        .then((res) => {
          this.balancesList.push({
            counterparty: "",
            currency: res[0].data.balance.currency,
            value: new BigNumber(res[0].data.balance.value).toFormat(),
          });
          this.codeAddress = res[0].data.codeAddress;
          //发行商不显示二级资产
          if (!res[0].data.spread) {
            res[1].data.balances.forEach((ele) => {
              this.balancesList.push({
                counterparty: ele.issuer,
                currency: ele.currency,
                value: new BigNumber(ele.value).toFormat(),
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$router.push("/err?err=account");
        });
    },
    accounts() {
      this.$axios(
        `${api.accounts}?address=${this.$route.query.address}&marker=${this.marker}&limit=${this.limit}`
      )
        .then((res) => {
          const list = res.data.transactions;
          list.map((data) => {
            this.data.push({
              hash: data.hash,
              type: this.getTradeTypeAccount(
                data.type,
                this.$route.query.address,
                data.account,
                data.destination
              ),
              count: data.amount ? data.amount : "--",
              time: dayjs(data.date * 1000).format("YYYY-MM-DD HH:mm:ss"),
              result: data.result,
              account: data.account,
              destination: data.destination,
              sourceType: data.type,
            });
          });
          this.ismore = res.data.marker ? true : false;
          this.marker = res.data.marker || "";
          this.loading = false;
          this.pageLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    queryContract() {
      this.queryLoading = true;
      this.$axios(
        `${api.contractQuery}?address=${this.$route.query.address}&opt=${this.form.opt}&args=${this.form.args}`
      )
        .then((res) => {
          this.queryLoading = false;
          this.isJSON = this.isJson(res.data.contractResult);
          this.contractResult.result = this.isJSON
            ? formatJson(res.data.contractResult)
            : res.data.contractResult;
          this.contractResult.status = "success";
        })
        .catch((err) => {
          this.queryLoading = false;
          this.isJSON = false;
          this.contractResult.result = err;
          this.contractResult.status = "error";
        });
    },
    loadMore() {
      this.pageLoading = true;
      this.accounts();
    },

    //格式化部署参数
    formatDeployParameter() {
      this.contractResult.result = formatJson(this.contractResult.result);
    },

    //二级通证更多
    more() {
      this.$router.push({
        path: "/assetslist",
        query: { address: this.$route.query.address },
      });
    },
    handleTabChange(v) {
      console.log(v);
    },

    /**
     * @name  判断是否为JSON
     */
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/var.less";
.accountinfo {
  .box();
  padding: 10px 20px;
  margin-bottom: 20px;
  overflow: hidden;
  .iconfont {
    font-size: 20px;
    cursor: pointer;
    color: @sdc-mainColor1;
    padding: 5px;
    &:hover {
      background: @mainbg;
      border-radius: 50%;
    }
  }
  .balance {
    li {
      float: left;
      width: 45%;
      list-style: none;
      line-height: 30px;
      border-bottom: 1px solid #dddcdc;
      .val {
        color: #4b5065;
        float: right;
        padding-right: 30px;
      }
      &.assets {
        float: left;
        width: 45%;
        margin-left: 10%;
        .value {
          float: right;
          padding-right: 5px;
        }
        .uni {
          color: @sdc-mainColor1;
          color: #4b5065;
          float: right;
          padding-right: 10px;
        }
        a {
          float: right;
          color: #7c7c7c;
        }
      }
    }
  }
  .address {
    border-bottom: 1px solid #dddcdc;
    margin-bottom: 8px;
    padding-bottom: 8px;
    color: @sdc-txtColor3;
  }
  .rinfo,
  .linfo {
    list-style: none;
    display: inline-block;
    width: 50%;
  }
  .rinfo {
    text-align: right;
    .select {
      text-align: left;
      margin-left: 20px;
    }
  }
}
.accountlist {
  margin-top: 10px;
  .box();
}
.more {
  text-align: center;
  padding: 30px 0;
}
.w-tit {
  font-size: 22px;
  color: #515a6e;
  text-align: center;
}
.w-addr {
  font-size: 22px;
  color: #1b3692;
  text-align: center;
}
.value {
  color: #4b5065;
}
.nft {
  float: right;
  color: rgb(51, 159, 250);
  cursor: pointer;
  padding-top: 5px;
}
.remark-body {
  color: #4b5065;
  width: 100%;
  padding: 20px;
  margin-top: 15px;
  background-color: #f8f9fb;
  border: none;
  resize: none;
}

.form-box {
  padding: 20px;
  border: 1px solid #dddddd;
  margin-top: 10px;
  background: #fff;
  width: 600px;
  .form-item {
    margin-bottom: 10px;
    label {
      display: inline-block;
      width: 100%;
      vertical-align: middle;
      box-sizing: border-box;
      margin-bottom: 5px;
    }
  }
  .form-btn {
    text-align: center;
    .ivu-btn {
      padding: 5px 32px 6px;
    }
  }
}

.relult-box {
  padding: 0 20px 20px;
  border: 1px solid #dddddd;
  margin-top: 20px;
  background: #fff;
  width: 600px;
  position: relative;
  .relult-tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    border-bottom: 1px solid #dddddd;
    span {
      &:nth-child(2) {
        color: #fff;

        border-radius: 6px;
        padding: 1px 5px;
      }
      &.f {
        background: rgba(254, 24, 12, 1);
      }
      &.s {
        background: rgba(20, 214, 10, 1);
      }
    }
  }
  .relult-text {
    .text-txt {
      margin-top: 10px;
      padding: 10px 20px;
      background: #f5f5f5;
    }
  }
}

/*悬浮操作按钮*/
.float-operate {
  position: absolute;
  right: 30px;
  top: 50px;
  z-index: 100;
  padding: 10px;
  box-sizing: border-box;
  .ivu-tooltip {
    display: block;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .operate-btn-icon,
  .ivu-icon {
    display: block;
    font-size: 18px;
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.5);
    }
  }
}

.tab-box {
  /deep/.ivu-radio-group-button .ivu-radio-wrapper-checked:hover,
  .ivu-radio-group-button .ivu-radio-wrapper:hover {
    border-color: #4da1ff;
    color: #fff;
    background: #4da1ff;
  }
  /deep/.ivu-radio-group-button .ivu-radio-wrapper-checked {
    border-color: #4da1ff;
    color: #fff;
    background: #4da1ff;
    box-shadow: -1px 0 0 0 transparent !important;
  }
}
</style>
